import axios from "axios";
import { config } from '../../config/Config';

export const requestGameAccess = async (obj) => {
    try {
        const response = await axios({
            method: 'post',
            url: `${config.serverBaseUrl}/v1/web/user-game-access`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${obj.accessToken}`
            },
            data: obj.request
        });
        return response.data;
    } catch (error) {
        console.error('Error requesting game access:', error.response?.data || error.message);
        throw error;
    }
};

export const getUserGameAccessRequests = async (obj) => {
    try {
        const response = await axios({
            method: 'get',
            url: `${config.serverBaseUrl}/v1/web/user-game-access`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${obj.accessToken}`
            },
            params: {
                approvingUserId: obj.approvingUserId
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching user game access requests:', error.response?.data || error.message);
        throw error;
    }
};

/**
 * Every access request the calling user has submitted (any status). Used by
 * the Games page to mark already-requested games as Pending (or Declined) so
 * the user doesn't double-request.
 */
export const getMyGameAccessRequests = async ({ accessToken }) => {
    try {
        const response = await axios({
            method: 'get',
            url: `${config.serverBaseUrl}/v1/web/user-game-access/my-requests`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching my game access requests:', error.response?.data || error.message);
        throw error;
    }
};

/**
 * The geographies a requester may ask to be scoped to on a game they do NOT have access to.
 *
 * Deliberately NOT /v1/web/player-segment/active: that read is gated on the Segmentation page,
 * which an ORG_MEMBER resolves to NO_ACCESS, so it 403s for exactly the users this form serves.
 * This endpoint is gated only on belonging to the game's org.
 *
 * An empty list is the normal answer for a game with no geographies — not an error.
 */
export const getRequestableGeographies = async ({ accessToken, gameId }) => {
    try {
        const response = await axios({
            method: 'get',
            url: `${config.serverBaseUrl}/v1/web/user-game-access/geographies/${gameId}`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            }
        });
        return response.data?.geographies || [];
    } catch (error) {
        console.error('Error fetching requestable geographies:', error.response?.data || error.message);
        return [];
    }
};

export const processGameAccessRequest = async (obj) => {
    try {
        const response = await axios({
            method: 'post',
            url: `${config.serverBaseUrl}/v1/web/user-game-access/${obj.requestId}/${obj.status}`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${obj.accessToken}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error processing game access request:', error.response?.data || error.message);
        throw error;
    }
};